import React, {useState, useEffect, useContext, useRef} from "react";
import GenericDialog from '../common/GenericDialog';
import axios from "../common/axios";
import {BrandContext} from "../common/BrandContext"

const StudentTestResultDialog = props => {
    const {open = false, handleClose, testAssignmentId, testAssignmentIds, studentId} = props;
    const [title, setTitle] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [studentTestResultDialogContent, setStudentTestResultDialogContent] = useState();
    const studentResultDialogRef = useRef();

    useEffect(() => {
        setTitle('');
        if(!open) {
            setStudentTestResultDialogContent(undefined);
            return;
        }

        if (!studentId || (!testAssignmentId && !testAssignmentIds)) {
            displayToastMessage('Error', 'Error getting student results', 'error', null,10000);
            handleClose();
            return;
        }

        setLoading(true);
        axios.get('/web/ui/sc/getUser', {params: {studentId: studentId}})
            .then(response => {
                setTitle('Results for ' + response.data.firstName + ' ' + response.data.lastName);

                axios.get('/controlCentre/studentResults.action', {
                    params: {
                        testAssignmentIdsStr: testAssignmentId ? testAssignmentId.toString()  : testAssignmentIds.toString(),
                        studentId: studentId
                    }
                }).then(response => {
                    setStudentTestResultDialogContent(response.data);
                    setLoading(false);
                }).catch(function (error) {
                    console.error('Error getting student results: ', error);
                    displayToastMessage('Error', 'Error getting student results', 'error', null,10000);
                    handleClose();
                });
            }).catch(function (error) {
                console.error('Error getting user: ', error);
                displayToastMessage('Error', 'Error getting user', 'error', null,10000);
                handleClose();
            });
    }, [open, studentId, testAssignmentId, testAssignmentIds]);

    useEffect(() => {
        if (studentTestResultDialogContent == undefined) {
            return;
        }

        if (studentResultDialogRef.current == undefined ) {
            return;
        }

        try {
            studentResultDialogRef.current.innerHTML = '';
            if (studentTestResultDialogContent != undefined) {
                const htmlFragment = document.createRange().createContextualFragment(studentTestResultDialogContent);
                studentResultDialogRef.current.appendChild(htmlFragment);
                $(studentResultDialogRef.current).reloadMathJax();
            }
        } catch (e) {
            console.log('Error loading content', e);
            if (typeof newrelic !== 'undefined') {
                newrelic.noticeError('Lesson error: ' + e);
            }
        }
    }, [studentTestResultDialogContent]);

    return (
        <GenericDialog
            open={open}
            title={title}
            isLoading={isLoading}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'md'}
            buttons={[
                {
                    name: 'PDF',
                    disabled: !studentId || (!testAssignmentId && !testAssignmentIds),
                    callback: async () => {
                        const url = "/reports/studentAdaptiveTestResultsReport.action?testAssignmentIdsStr=" + (testAssignmentId ? testAssignmentId.toString()  : testAssignmentIds.toString()) + '&studentId=' + studentId;
                        const pdfWin = window.open(url);
                        pdfWin.focus();

                        return Promise.resolve();
                    }
                },
                {name: 'Close'}
            ]}
        >
            <div className={'test-result-dialog-blk'} ref={studentResultDialogRef}></div>
        </GenericDialog>
    )
}

export default StudentTestResultDialog;
